export default __webpack_public_path__ + "static/media/Group.a923c2a2.svg";